import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateUniversalLoader } from './translate-universal-loader';
import { provideAnimations } from '@angular/platform-browser/animations';
import { tokenInterceptorFn } from './core/http/token.interceptor';
import { provideMatomo, withRouter, withRouteData } from 'ngx-matomo-client';

import { environment } from '../../../commondata/environments/environment';
import { MAT_DATE_LOCALE } from '@angular/material/core';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    [{ provide: MAT_DATE_LOCALE, useValue: "it-IT" }],
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([tokenInterceptorFn])),
    provideFirebaseApp(() => initializeApp(environment.configFirebase)),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    provideMatomo(
      { trackerUrl: "https://matomo.anastasis.it/", siteId: (environment.production ? "4" : "7") },
      withRouter(),
      withRouteData()
    ),
    importProvidersFrom([
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: TranslateUniversalLoader,
          deps: [HttpClient],
        },
      }),
    ]),
  ],
};

// function withProviders(): import("@angular/common/http").HttpFeature<import("@angular/common/http").HttpFeatureKind> {
//   throw new Error('Function not implemented.');
// }
